import script from "./convert.vue?vue&type=script&lang=ts&setup=true"
export * from "./convert.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__